import { Flex, TextField } from '@radix-ui/themes';
import { CheckCircleIcon } from '@/components/icons';

export default function FormField({
  field,
  label,
  labelHelp,
  description,
  defaultValue,
  value,
  placeholder,
  onChange,
  onBlur,
  readOnly,
  required,
  error,
  size = '3',
  type = 'text',
  mask,
  slot,
  suffix,
  inputProps = {},
  completed,
  children,
}) {
  return (
    <div>
      <label
        htmlFor={field}
        className="block text-sm font-medium leading-6 text-gray-900"
      >
        <Flex gap="1">
          {label}
          {!!completed && (
            <CheckCircleIcon
              size={20}
              weight="fill"
              className="shrink-0 text-teal-600 mt-0.5"
            />
          )}
        </Flex>
      </label>
      <Description text={description} />
      <div className="mt-2">
        {children || (
          <TextField.Root
            readOnly={readOnly}
            required={required}
            size={size}
            type={type}
            id={field}
            name={field}
            defaultValue={defaultValue}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            onBlur={onBlur}
            {...inputProps}
          >
            {mask && <TextField.Slot className="pr-1">{mask}</TextField.Slot>}
            {slot}
            {suffix && <TextField.Slot side="right">{suffix}</TextField.Slot>}
          </TextField.Root>
        )}
      </div>
      <LabelHelp text={labelHelp} />
      <FieldError error={error} />
    </div>
  );
}

export function Description({ text }) {
  if (!text) return;
  return <p className="mt-1 mb-3 text-sm text-gray-600">{text}</p>;
}

export function LabelHelp({ text }) {
  if (!text) return;
  return <p className="mt-2 text-sm text-gray-500">{text}</p>;
}

export function FieldError({ error }) {
  if (!error) return;
  return (
    <p className="mt-2 text-sm text-red-600">{[].concat(error).join('; ')}</p>
  );
}
